import React, { useState, useEffect, useMemo } from "react";

import DateTimePicker from "./DateTimePicker.js";
import MultiSelect from "./MultiSelect.js";
import SecondCollapsibleTable from "./tables/SecondCollapsibleTable.js";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import { excelAFecha  } from "../functions/functions.js";

import { Box, Button } from "@mui/material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { MainButton } from "../SXStyle.jsx";
import * as XLSX from "xlsx";


function SecondDynamicTable({ visible, dataExcel, openLoader, setOpenLoader }) {
  
  //catalogos
  const [movimientos, setMovimientos] = useState([]);
  const [zonas, setZonas] = useState([]);
  const [materiales, setMateriales] = useState([]);

  //result
  const [finalData, setFinalData] = useState([]);
  const [resumenPonderados, setResumenPonderados] = useState([]);
  
  //filtros
  const [filtrosSeleccionados, setFiltrosSeleccionados] = useState({
    fecha: null,
    fechaInicio: null,
    fechaFinal: null,
    strfechaInicio: "",
    strfechaFinal: "",
    materiales: [],
    movimientos: [],
    zonas: [],
  });

  const dataMovimientos = [
    "01_MINERAL_TUMBADO",
    "03_PRODUCCION_TEPETATE",
    "02_PRODUCCION",
    "04_REMANEJO",
    "05_ALIMENTACION",
    "06_MOVIMIENTO BANDA",
    "06_ENTRADA A MHS",
  ];

  const dataZonas = [
    "MDL",
    "ML-",
    "MLL",
    "MLU",
    "MML",
    "STO",
    "EPO",
    "INT",
    "NIV",
    "ML_",
    "MHS",
    "STA"
  ];

  const dataMateriales = [
    "INCREMENTAL",
    "MINERAL",
    "TEPETATE",
    "SUBINCREMENTAL"
  ];
  
  //agrupa por fechas y calcula ponderados
  useEffect(() => {
    if (dataExcel.length > 0) {
      fetchExcel();
      setOpenLoader(false);
    }
  }, [dataExcel]);

  const fetchExcel = async () => {
    try {
      //agrupa por fechas
      let preResult = agruparPorMovimientoYFecha(dataExcel);

      //calcula los ponderados
      const datosPonderados = ponderadosCalculadosPorMovimiento(preResult);
      setFinalData(datosPonderados);

      //calcula el resumen de los ponderados
      setResumenPonderados(resumenPonderadosCalculados(datosPonderados));

    } catch (err) {
      console.error(err);
    }
  };

  //filtra la informacion
  useEffect(() => {
    if (dataExcel.length === 0) return;
    
    if(filtrosSeleccionados.length === 0) return;

    setOpenLoader(true);
    
    // Dejamos tiempo para que el loader se muestre antes del procesamiento
    setTimeout(() => {
      //Rango de fechas
      const fechaInicio = filtrosSeleccionados.fechaInicio;
      const fechaFinal = filtrosSeleccionados.fechaFinal;
      
      // Filtra la informacion
      const resultDatosFiltrados = dataExcel.filter(row => {
      
        const fechaExcel = row[2];    //filtro de fechas
        const tipoZona = row[5]       //filtro zona 
        const tipoMaterial = row[14]  //filtro material
        const tipoMovimiento = row[4] //filtro movimiento
        
        //aplica el filtro de fechas
        const fechasFiltradas = fechaInicio == null || fechaFinal == null || (fechaExcel >= fechaInicio && fechaExcel <= fechaFinal);

        //aplica el filtro de zonas
        const zonasFiltradas = filtrosSeleccionados.zonas?.length == 0 || filtrosSeleccionados.zonas.includes(tipoZona);
          
        //aplica el filtro de materiales
        const materialesFiltrados = filtrosSeleccionados.materiales?.length == 0 || filtrosSeleccionados.materiales.includes(tipoMaterial);

         //aplica el filtro de movimiento
        const movimientosFiltrados = filtrosSeleccionados.movimientos?.length == 0 || filtrosSeleccionados.movimientos.includes(tipoMovimiento);

        return fechasFiltradas && zonasFiltradas && materialesFiltrados && movimientosFiltrados;
      });

      //agrupa por fechas
      let preResult = agruparPorMovimientoYFecha(resultDatosFiltrados);
      const datosPonderados = ponderadosCalculadosPorMovimiento(preResult);
      setFinalData(datosPonderados);

      //calcula el resumen de los ponderados
      setResumenPonderados(resumenPonderadosCalculados(datosPonderados));

      setOpenLoader(false);
      
    }, 0); // Deja que se renderice el loader primero
    
  }, [filtrosSeleccionados]);



  function agruparPorMovimientoYFecha(dataLista) {
    const agrupado = {};

    // Filtrar solo movimientos deseados
    const arrayDesarrollos = dataLista.filter(
      (item) => item[6] === "DESARROLLO LATERAL" || item[6] === "PRODUCCION BL"
    );

    arrayDesarrollos.forEach((registro) => {
      const movimiento = registro[6];
      const serialFecha = registro[2];
      const fecha = excelAFecha(serialFecha);

      if (!agrupado[movimiento]) {
        agrupado[movimiento] = {
          Etiquetas_de_fila: movimiento,
          Toneladas: "pendiente",
          AuEq_Gr_t: "pendiente",
          Au_Gr_t: "pendiente",
          Ag_gr_t: "pendiente",
          Cu_pct: "pendiente",
          Fe_pct: "pendiente",
          S_pct: "pendiente",
          As_pct: "pendiente",
          Bi_ppm: "pendiente",
          Cd_ppm: "pendiente",
          Zn_pct: "pendiente",
          AuEq_Oz: "pendiente",
          dataFechas: [], // agruparemos por fecha aquí
        };
      }

      if (!agrupado[movimiento].dataFechas[fecha]) {
        agrupado[movimiento].dataFechas[fecha] = {
          Fecha: fecha,
          Toneladas: "pendiente",
          AuEq_Gr_t: "pendiente",
          Au_Gr_t: "pendiente",
          Ag_gr_t: "pendiente",
          Cu_pct: "pendiente",
          Fe_pct: "pendiente",
          S_pct: "pendiente",
          As_pct: "pendiente",
          Bi_ppm: "pendiente",
          Cd_ppm: "pendiente",
          Zn_pct: "pendiente",
          AuEq_Oz: "pendiente",
          dataAgrupada: [],
        };
      }

      agrupado[movimiento].dataFechas[fecha].dataAgrupada.push(registro);
    });

    // Convertimos a array final
    return Object.values(agrupado).map((grupoMov) => {
      return {
        Etiquetas_de_fila: grupoMov.Etiquetas_de_fila,
        Toneladas: grupoMov.Toneladas,
        AuEq_Gr_t: grupoMov.AuEq_Gr_t,
        Au_Gr_t: grupoMov.Au_Gr_t,
        Ag_gr_t: grupoMov.Ag_gr_t,
        Cu_pct: grupoMov.Cu_pct,
        Fe_pct: grupoMov.Fe_pct,
        S_pct: grupoMov.S_pct,
        As_pct: grupoMov.As_pct,
        Bi_ppm: grupoMov.Bi_ppm,
        Cd_ppm: grupoMov.Cd_ppm,
        Zn_pct: grupoMov.Zn_pct,
        AuEq_Oz: grupoMov.AuEq_Oz,
        dataFechas: grupoMov.dataFechas,
      };
    });
  }


  //calcula los ponderamos de cada fecha Y movimiento
  function ponderadosCalculadosPorMovimiento(agrupado) {
    const resultado = [];

    Object.entries(agrupado).forEach(([movimiento, grupoMovimiento]) => {

      const fechasCalculadas = [];

      // Totales por movimiento
      let totalToneladasMov = 0;
      let sumAuEq_Gr_tMov = 0;
      let sumAu_Gr_tMov = 0;
      let sumAg_gr_tMov = 0;
      let sumCu_pctMov = 0;
      let sumFe_pctMov = 0;
      let sumS_pctMov = 0;
      let sumAs_pctMov = 0;
      let sumBi_ppmMov = 0;
      let sumCd_ppmMov = 0;
      let sumZn_pctMov = 0;
      let sumAuEq_OzMov = 0;

      Object.entries(grupoMovimiento.dataFechas).forEach(
        ([fechaKey, grupoFecha]) => {
          const registros = grupoFecha.dataAgrupada;

          let totalToneladas = 0;
          let sumAuEq_Gr_t = 0;
          let sumAu_Gr_t = 0;
          let sumAg_gr_t = 0;
          let sumCu_pct = 0;
          let sumFe_pct = 0;
          let sumS_pct = 0;
          let sumAs_pct = 0;
          let sumBi_ppm = 0;
          let sumCd_ppm = 0;
          let sumZn_pct = 0;
          let sumAuEq_Oz = 0;

          registros.forEach((registro) => {
            const toneladas = Number(registro[13]) || 0;
            const auEq_Gr_t = Number(registro[16]) || 0;

            totalToneladas += toneladas;
            sumAu_Gr_t += toneladas * Number(registro[17]) || 0;
            sumAg_gr_t += toneladas * (Number(registro[19]) || 0);
            sumCu_pct += toneladas * (Number(registro[20]) || 0);
            sumAuEq_Gr_t += toneladas * auEq_Gr_t;
            sumFe_pct += toneladas * (Number(registro[21]) || 0);
            sumS_pct += toneladas * (Number(registro[26]) || 0);
            sumAs_pct += toneladas * (Number(registro[22]) || 0);
            sumBi_ppm += toneladas * (Number(registro[23]) || 0);
            sumCd_ppm += toneladas * (Number(registro[24]) || 0);
            sumZn_pct += toneladas * (Number(registro[25]) || 0);
            sumAuEq_Oz += toneladas * auEq_Gr_t;

            // Agrega AuEq_Oz individual al registro
            const AuEqOzIndividual =
              toneladas && auEq_Gr_t
                ? ((toneladas * auEq_Gr_t) / 31.1035).toFixed(2)
                : "0.0";
            registro.push(AuEqOzIndividual);
          });

          // Acumulamos en el movimiento
          totalToneladasMov += totalToneladas;
          sumAu_Gr_tMov += sumAu_Gr_t;
          sumAg_gr_tMov += sumAg_gr_t;
          sumCu_pctMov += sumCu_pct;
          sumAuEq_Gr_tMov += sumAuEq_Gr_t;
          sumFe_pctMov += sumFe_pct;
          sumS_pctMov += sumS_pct;
          sumAs_pctMov += sumAs_pct;
          sumBi_ppmMov += sumBi_ppm;
          sumCd_ppmMov += sumCd_ppm;
          sumZn_pctMov += sumZn_pct;
          sumAuEq_OzMov += sumAuEq_Oz;

          // Calcula los promedios ponderados por fecha
          const dividir = (total) =>
            totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";
          const dividirSiError = (total) =>
            totalToneladas > 0 && total > 0
              ? (total / 31.1035).toFixed(2)
              : "0.00";

          fechasCalculadas[fechaKey] = {
            ...grupoFecha,
            Toneladas: totalToneladas.toFixed(2),
            AuEq_Gr_t: dividir(sumAuEq_Gr_t),
            Au_Gr_t: dividir(sumAu_Gr_t),
            Ag_gr_t: dividir(sumAg_gr_t),
            Cu_pct: dividir(sumCu_pct),
            Fe_pct: dividir(sumFe_pct),
            S_pct: dividir(sumS_pct),
            As_pct: dividir(sumAs_pct),
            Bi_ppm: dividir(sumBi_ppm),
            Cd_ppm: dividir(sumCd_ppm),
            Zn_pct: dividir(sumZn_pct),
            AuEq_Oz: dividirSiError(sumAuEq_Oz),
          };
        }
      );

      // Fórmulas para totales del movimiento
      const dividirMov = (total) =>
        totalToneladasMov ? (total / totalToneladasMov).toFixed(2) : "0.00";
      const dividirMovSiError = (total) =>
        totalToneladasMov > 0 && total > 0
          ? (total / 31.1035).toFixed(2)
          : "0.00";

      resultado.push({
        Etiquetas_de_fila: grupoMovimiento.Etiquetas_de_fila,
        Toneladas: totalToneladasMov.toFixed(2),
        AuEq_Gr_t: dividirMov(sumAuEq_Gr_tMov),
        Au_Gr_t: dividirMov(sumAu_Gr_tMov),
        Ag_gr_t: dividirMov(sumAg_gr_tMov),
        Cu_pct: dividirMov(sumCu_pctMov),
        Fe_pct: dividirMov(sumFe_pctMov),
        S_pct: dividirMov(sumS_pctMov),
        As_pct: dividirMov(sumAs_pctMov),
        Bi_ppm: dividirMov(sumBi_ppmMov),
        Cd_ppm: dividirMov(sumCd_ppmMov),
        Zn_pct: dividirMov(sumZn_pctMov),
        AuEq_Oz: dividirMovSiError(sumAuEq_OzMov),
        dataFechas: Object.values(fechasCalculadas),
      });
    });

    return resultado;
  }

  
  //calcula los ponderados finales (resumen)
  function resumenPonderadosCalculados(agrupado) {

    let totalToneladas = 0;
    let sumAuEq_Gr_t = 0;
    let sumAu_Gr_t = 0;
    let sumAg_gr_t = 0;
    let sumCu_pct = 0;
    let sumFe_pct = 0;
    let sumS_pct = 0;
    let sumAs_pct = 0;
    let sumBi_ppm = 0;
    let sumCd_ppm = 0;
    let sumZn_pct = 0;
    let sumAuEq_Oz = 0;

    agrupado.forEach((item, index) => {
      const toneladas = Number(item.Toneladas) || 0;
      const auEq_Gr_t = Number(item.AuEq_Gr_t) || 0;
      totalToneladas += toneladas;

      sumAu_Gr_t += toneladas * (Number(item.Au_Gr_t) || 0); //='Au * tons'/Toneladas
      sumAg_gr_t += toneladas * (Number(item.Ag_gr_t) || 0); //='Ag * tons'/Toneladas

      sumCu_pct += toneladas * (Number(item.Cu_pct) || 0); //='Cu% * tons '/Toneladas
      sumAuEq_Gr_t += toneladas * auEq_Gr_t; //='AuEq * tons'/Toneladas
      sumFe_pct += toneladas * (Number(item.Fe_pct) || 0); //='Fe * tons'/Toneladas

      sumS_pct += toneladas * (Number(item.S_pct) || 0); //='S% * tons'/Toneladas
      sumAs_pct += toneladas * (Number(item.As_pct) || 0); //='AS*T'/Toneladas
      sumBi_ppm += toneladas * (Number(item.Bi_ppm) || 0); //='Bi*t'/Toneladas
      sumCd_ppm += toneladas * (Number(item.Cd_ppm) || 0); //='Cd*t'/Toneladas
      sumZn_pct += toneladas * (Number(item.Zn_pct) || 0); //='Zn*t'/Toneladas
      sumAuEq_Oz += toneladas * auEq_Gr_t; //= SI.ERROR(('AuEq Gr/t '*Toneladas)/31.1035,0)
    });

    const dividir = (total) =>
      totalToneladas ? (total / totalToneladas).toFixed(2) : "0.00";
    const dividirSiError = (total) =>
      totalToneladas > 0 && total > 0 ? (total / 31.1035).toFixed(2) : "0.00";

    let result = {
      Toneladas: totalToneladas.toFixed(2),
      AuEq_Gr_t: dividir(sumAuEq_Gr_t),
      Au_Gr_t: dividir(sumAu_Gr_t),
      Ag_gr_t: dividir(sumAg_gr_t),
      Cu_pct: dividir(sumCu_pct),
      Fe_pct: dividir(sumFe_pct),
      S_pct: dividir(sumS_pct),
      As_pct: dividir(sumAs_pct),
      Bi_ppm: dividir(sumBi_ppm),
      Cd_ppm: dividir(sumCd_ppm),
      Zn_pct: dividir(sumZn_pct),
      AuEq_Oz: dividirSiError(sumAuEq_Oz),
    };

    return result;
  }


  const handleMovimientos = (event) => {
    const value = event.target.value;
    const seleccionados = typeof value === "string" ? value.split(",") : value;

    const totalSinTodos = dataMovimientos.filter((d) => d !== "TODOS");
    const seleccionSinTodos = seleccionados.filter((v) => v !== "TODOS");

    // Caso 1: Si se hace clic en "TODOS"
    if (seleccionados.includes("TODOS")) {
      const isAllSelected = movimientos.length === totalSinTodos.length;
      const nuevosValores = isAllSelected ? [] : totalSinTodos;
      setMovimientos(nuevosValores);
      setFiltrosSeleccionados((prev) => ({
        ...prev,
        movimientos: nuevosValores,
      }));
      return;
    }

    // Caso 2: Selección normal (quitar uno, agregar uno)
    setMovimientos(seleccionSinTodos);

    setFiltrosSeleccionados((prev) => ({
      ...prev,
      movimientos: seleccionSinTodos,
    }));
  };


  const handleZonas = (event) => {
    const value = event.target.value;
    const seleccionados = typeof value === "string" ? value.split(",") : value;

    const totalSinTodos = dataZonas.filter((d) => d !== "TODOS");
    const seleccionSinTodos = seleccionados.filter((v) => v !== "TODOS");

    // Caso 1: Si se hace clic en "TODOS"
    if (seleccionados.includes("TODOS")) {
      const isAllSelected = zonas.length === totalSinTodos.length;
      const nuevosValores = isAllSelected ? [] : totalSinTodos;
      setZonas(nuevosValores);
      setFiltrosSeleccionados((prev) => ({
        ...prev,
        zonas: nuevosValores,
      }));
      return;
    }

    // Caso 2: Selección normal (quitar uno, agregar uno)
    setZonas(seleccionSinTodos);

    setFiltrosSeleccionados((prev) => ({
      ...prev,
      zonas: seleccionSinTodos,
    }));
  };

  const handleMateriales = (event) => {
    const value = event.target.value;
    const seleccionados = typeof value === "string" ? value.split(",") : value;

    const totalSinTodos = dataMateriales.filter((d) => d !== "TODOS");
    const seleccionSinTodos = seleccionados.filter((v) => v !== "TODOS");

    // Caso 1: Si se hace clic en "TODOS"
    if (seleccionados.includes("TODOS")) {
      const isAllSelected = materiales.length === totalSinTodos.length;
      const nuevosValores = isAllSelected ? [] : totalSinTodos;
      setMateriales(nuevosValores);
      setFiltrosSeleccionados((prev) => ({
        ...prev,
        materiales: nuevosValores,
      }));
      return;
    }

    // Caso 2: Selección normal (quitar uno, agregar uno)
    setMateriales(seleccionSinTodos);

    setFiltrosSeleccionados((prev) => ({
      ...prev,
      materiales: seleccionSinTodos,
    }));
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(finalData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    XLSX.writeFile(workbook, `DesarrolloLateral/ProduccionRebajes.xlsx`);
  };

  const tablaRender = useMemo(() => {
    return <SecondCollapsibleTable rows={finalData} resumenPonderados={resumenPonderados} />;
  }, [finalData]);
  

  return (
    <div className="p-4 rounded-lg shadow-lg  bg-ceniza_light border-gray-600 mt-1 w-full">
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div  className="grid grid-cols-3">
        <DateTimePicker
          filtrosSeleccionados={filtrosSeleccionados}
          setFiltrosSeleccionados={setFiltrosSeleccionados}
        />

         <MultiSelect
          label="Movimientos"
          data={dataMovimientos}
          items={movimientos}
          handleChange={handleMovimientos}
        />

        <MultiSelect
          label="Zonas"
          data={dataZonas}
          items={zonas}
          handleChange={handleZonas}
        />
        
        <MultiSelect
          label="Materiales"
          data={dataMateriales}
          items={materiales}
          handleChange={handleMateriales}
        />

        <div></div>

        <Button
          onClick={() => exportToExcel()}
          variant="contained"
          sx={{ ...MainButton, width: "120px", marginTop: "40px" }}
          endIcon={<CloudDownloadIcon />}
        >
          Exportar
        </Button>

       
      </div>

      <div className="mt-3 h-[60vh] overflow-y-auto">
        {tablaRender}
      </div>
    </div>
  );
}

export default SecondDynamicTable;
